import { ConditionalText, Text } from '@shared/components'
import { Card, Flex, theme, Typography } from 'antd'

import { useTranslation } from 'react-i18next'

import { useStyles } from './styles'

import type { CardProps } from 'antd/lib'
import type { Icon } from 'iconsax-react'
import type { Key, ReactNode } from 'react'

const { Title } = Typography

type InfoItem = {
  icon: Icon
  label: string
  text?: ReactNode
}

type Props = {
  key: Key
  info: InfoItem[]
  titleKey?: string
} & CardProps

export const ContactDetailsCard = ({
  key,
  info,
  titleKey,
  ...props
}: Props) => {
  const { styles } = useStyles()
  const { t } = useTranslation()
  const { token } = theme.useToken()

  return (
    <Card
      title={
        <Title level={4}>
          {t(titleKey ? titleKey : 'billing.general_information')}
        </Title>
      }
      className="w-full"
      {...props}
    >
      <Flex vertical gap={8}>
        {info.map(({ icon: Icon, label, text }, index) => (
          <Flex key={`${key}-${index}`} align="center" gap={6}>
            <Icon
              size={16}
              color={token.colorTextSecondary}
              className={styles.icon}
            />
            <Text className={styles.noWrap}>{label}:</Text>

            <ConditionalText strong condition={!!text}>
              {text}
            </ConditionalText>
          </Flex>
        ))}
      </Flex>
    </Card>
  )
}
